import { render, staticRenderFns } from "./base_token.vue?vue&type=template&id=3c0bfcdc&"
import script from "./base_token.vue?vue&type=script&lang=js&"
export * from "./base_token.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports